export default "__VITE_ASSET__9THm0hS6__"